<div class="flex flex-col grow relative">
  <div class="w-full relative"
       [ngStyle]="{'height': streetViewActive() ? '50%' : '100%' }">

    <google-map
        class="h-full w-full"
        height="inherit"
        width="inherit"
        [options]="MAP_OPTIONS"
        (mapClick)="closeInfoWindow()"
        (boundsChanged)="updateMapLoading(true)"
        (idle)="updateMapLoading(false)">

      <map-marker-clusterer>
        @for (marker of markers(); track marker.id) {
          <app-cv-marker #cvMarkerComponent
                         [mapsFullyRendered]="mapsFullyRendered()"
                         [googleMapDirective]="googleMapDirective()"
                         [marker]="marker"
                         [isHovered]="hoveredMarkerId() === marker.id"
                         [minimizeMarkers]="markersMinimized()"
                         [streetViewActive]="streetViewActive()"
                         [validationHistory]="validationHistory()"
                         (markerClick)="openCvInfoWindow(cvMarkerComponent.mapAdvancedMarker(), marker.id)"
                         (markerDrag)="onMapDrag(marker, $event)"
                         (markerMouseover)="onCvMarkerMouseover(marker.id)"
                         (markerMouseout)="onCvMarkerMouseout()"/>
        }
      </map-marker-clusterer>

      @if (customMarker()) {
        <app-cv-marker #customMarkerComponent
                       [mapsFullyRendered]="mapsFullyRendered()"
                       [googleMapDirective]="googleMapDirective()"
                       [marker]="customMarker()"
                       [isHovered]="hoveredMarkerId() === customMarker().id"
                       [minimizeMarkers]="markersMinimized()"
                       [streetViewActive]="streetViewActive()"
                       [validationHistory]="validationHistory()"
                       (markerClick)="openCvInfoWindow(customMarkerComponent.mapAdvancedMarker(), customMarker().id)"
                       (markerDrag)="onMapDrag(customMarker(), $event)"
                       (markerMouseover)="onCvMarkerMouseover(customMarker().id)"
                       (markerMouseout)="onCvMarkerMouseout()"/>
      }

      @if (autocompleteMarker()) {
        <app-cv-marker [marker]="autocompleteMarker()"
                       [mapsFullyRendered]="mapsFullyRendered()"
                       [googleMapDirective]="googleMapDirective()"
                       [isHovered]="hoveredMarkerId() === autocompleteMarker().id"
                       [minimizeMarkers]="markersMinimized()"
                       [streetViewActive]="streetViewActive()"
                       [validationHistory]="validationHistory()"
                       (markerDrag)="onMapDrag(autocompleteMarker(), $event)"
                       (markerMouseover)="onCvMarkerMouseover(autocompleteMarker().id)"
                       (markerMouseout)="onCvMarkerMouseout()"/>
      }

      <map-info-window>
        <app-cv-info-window-content [marker]="infoWindowMarker()"
                                    [focusedLocation]="focusedLocation()"
                                    [validationHistory]="validationHistory()"
                                    [lastValidation]="lastValidation()"
                                    (processMarkerAction)="processMarkerAction($event)"/>
      </map-info-window>
    </google-map>

    @if (mapLoading() || validationHistoryLoading()) {
      <mat-progress-bar
          [mode]="'indeterminate'"
          class="absolute left-0 top-0 z-[999]"></mat-progress-bar>
    }
  </div>

  <div #streetViewContainer
       class="w-full relative"
       [ngStyle]="{'height': streetViewActive() ? '50%' : '0%' }">
    <button mat-icon-button
            class="absolute right-[10px] top-[10px] z-[999] rounded-none bg-neutral-10"
            (click)="closeStreetView()">
      <mat-icon svgIcon="close" class="text-neutral-90 hover:text-white"></mat-icon>
    </button>

    @if (streetViewLoading()) {
      <mat-progress-bar
          [mode]="'indeterminate'"
          class="absolute left-0 top-0 z-[999]"></mat-progress-bar>
    }
  </div>

  <div class="absolute top-[8px] left-[8px]">
    <app-cv-map-ui [googleMap]="googleMapDirective()"
                   [focusedLocation]="focusedLocation()"
                   [customMarker]="customMarker()"
                   [canContinueAfterValidation]="canContinueAfterValidation()"
                   [continueAfterValidationActive]="continueAfterValidation()"
                   [cvButtonActive]="cvButtonActive()"
                   [markersMinimized]="markersMinimized()"
                   [rightPanelWidth]="rightPanelWidth()"
                   [showValidationHistoryActive]="showValidationHistory()"
                   [streetViewClosedByUser]="streetViewClosedByUser()"
                   (toggleCvMode)="onToggleCvMode()"
                   (showValidationHistory)="onShowHistory($event)"
                   (toggleMinimizeMarkers)="onToggleMinimizeMarkers()"
                   (placeAutocompleteMarker)="onPlaceAutocompleteMarker($event)"
                   (placeCustomCvMarker)="onPlaceCustomMarker($event)"
                   (continueAfterValidation)="onContinueAfterValidation($event)"/>
  </div>
</div>

